import { MapPin, Instagram, Music2, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer
            className="relative border-t border-white/5 bg-[#030303] py-20 px-6 md:px-12"
            data-testid="main-footer"
        >
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-400/40 to-transparent" />
            <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <h3 className="font-display text-2xl font-medium tracking-tight text-white">
                        Studio Mon Séraphin
                    </h3>
                    <p className="mt-4 max-w-md font-body text-sm leading-relaxed text-zinc-500">
                        Le studio podcast clé-en-main pour entrepreneurs, créateurs
                        et PME. Enregistrement, montage, stratégie — tout sous le
                        même toit, à quelques minutes de Paris.
                    </p>
                    <div className="mt-6 flex items-center gap-3">
                        <a
                            href="https://instagram.com"
                            target="_blank"
                            rel="noreferrer"
                            className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-zinc-400 hover:text-amber-400 hover:border-amber-400/50 transition-all"
                            data-testid="social-instagram"
                        >
                            <Instagram className="w-4 h-4" />
                        </a>
                        <a
                            href="https://tiktok.com"
                            target="_blank"
                            rel="noreferrer"
                            className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-zinc-400 hover:text-amber-400 hover:border-amber-400/50 transition-all"
                            data-testid="social-tiktok"
                        >
                            <Music2 className="w-4 h-4" />
                        </a>
                    </div>
                </div>

                <div>
                    <h4 className="font-display text-xs uppercase tracking-[0.3em] text-amber-400/80">
                        Studio
                    </h4>
                    <ul className="mt-4 space-y-3 text-sm text-zinc-400 font-body">
                        <li className="flex items-start gap-2">
                            <MapPin className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
                            <span>
                                5 Boulevard Georges Méliès
                                <br />
                                Villiers-sur-Marne
                                <br />
                                <span className="text-zinc-500">RER A Noisy-le-Grand – Mont d'Est (13 min à pied) · RER E Villiers-sur-Marne</span>
                            </span>
                        </li>
                        <li className="flex items-center gap-2">
                            <Mail className="w-4 h-4 text-amber-400 shrink-0" />
                            <a
                                href="mailto:admin@monseraphinstudio.fr"
                                className="hover:text-amber-300"
                            >
                                admin@monseraphinstudio.fr
                            </a>
                        </li>
                        <li className="flex items-center gap-2">
                            <Phone className="w-4 h-4 text-amber-400 shrink-0" />
                            <a href="tel:+33758818179" className="hover:text-amber-300">+33 7 58 81 81 79</a>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display text-xs uppercase tracking-[0.3em] text-amber-400/80">
                        Naviguer
                    </h4>
                    <ul className="mt-4 space-y-3 text-sm text-zinc-400 font-body">
                        <li>
                            <Link to="/reserver" className="hover:text-amber-300" data-testid="footer-reserver">
                                Réserver une session
                            </Link>
                        </li>
                        <li>
                            <a href="#formules" className="hover:text-amber-300">
                                Formules & tarifs
                            </a>
                        </li>
                        <li>
                            <a href="#faq" className="hover:text-amber-300">
                                FAQ
                            </a>
                        </li>
                        <li>
                            <Link
                                to="/admin/login"
                                className="text-zinc-600 hover:text-amber-300"
                                data-testid="footer-admin-link"
                            >
                                Espace admin
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mt-16 pt-8 border-t border-white/5 max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
                <p className="text-xs text-zinc-600 font-body">
                    © {new Date().getFullYear()} Studio Mon Séraphin — Tous droits réservés.
                </p>
                <p className="text-xs text-zinc-600 font-body">
                    Fait avec passion pour les voix qui comptent.
                </p>
            </div>
        </footer>
    );
}
